module.exports = __webpack_public_path__ + "static/media/10.fc93e9c2.png";